import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { archiveAlertsBulkActionType, deleteAlertsBulkActionType, } from '../../../../../../backend/features/alerts/bulk-actions';
import { useAlertUiTranslation } from '../../../../../hooks';
export const AlertActionsArchived = ({ data, onReload, onCloseDialog }) => {
    const { t } = useAlertUiTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: t('common.restore') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showConfirmDialog({
                        title: t('restoreArchivedAlertsDialog.title', { count: 1, page: 'Sent' }),
                        content: t('restoreArchivedAlertsDialog.message', { count: 1, page: 'Sent' }),
                        confirmLabel: t('common.restore'),
                        onConfirm: () => {
                            launchBulkAction({
                                type: archiveAlertsBulkActionType, // TODO currently Alert Service backend does not support separate "restore" action, calling archive just toggles archived state
                                title: t('restoreArchivedAlertsDialog.progress', { count: 1 }),
                                runSync: true,
                                params: { alertIds: [data.id] },
                                onClose: () => {
                                    onReload(true);
                                    onCloseDialog();
                                },
                            });
                        },
                    });
                } },
                React.createElement(UnarchiveOutlinedIcon, null))),
        React.createElement(Tooltip, { title: t('common.delete') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showConfirmDialog({
                        title: t('deleteArchivedAlertsDialog.title', { count: 1 }),
                        content: t('deleteArchivedAlertsDialog.message', { count: 1 }),
                        confirmLabel: t('common.delete'),
                        onConfirm: () => {
                            launchBulkAction({
                                type: deleteAlertsBulkActionType,
                                title: t('deleteArchivedAlertsDialog.progress', { count: 1 }),
                                runSync: true,
                                params: { alertIds: [data.id] },
                                onClose: () => {
                                    onReload(true);
                                    onCloseDialog();
                                },
                            });
                        },
                    });
                } },
                React.createElement(DeleteOutlinedIcon, null)))));
};
